export { default as CardRowSkeleton } from './component';
